import { Field } from '#/components/Form/Field/Field';
import { PhoneInputLoadable } from '#/components/PhoneInput/PhoneInputLoadable';
import { ClientOnly } from '#/containers/ClientOnly';

type Props = {
  name: string;
  label?: string;
  description?: string;
  disabled?: boolean;
};

export function RequestedPhoneUserField({
  name,
  label,
  description,
  disabled,
}: Props) {
  const subName = `${name}.phone`;

  return (
    <Field
      customErrorMatch={(errors) => errors[name] ?? errors[subName]}
      name={name}
      label={label}
      description={description}
      renderInput={({ qaId, updateValue, id }) => (
        <ClientOnly>
          <PhoneInputLoadable
            className="phone-input"
            name={name}
            id={id}
            qaId={`${qaId}-hidden-input`}
            disabled={disabled}
            placeholder="+12345678910"
            onChange={(v?: string) => {
              updateValue({
                type: 'PHONE',
                phone: v,
              });
            }}
          />
        </ClientOnly>
      )}
    />
  );
}
